import { createContext, useContext } from "react";

export type User = {
    name: string;
    username: string;
    role: string;
};

export const UserContext = createContext<User | null>(null);

export const useUser = () => useContext(UserContext);